// Clinic Configuration for Pearland Dental care
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Pearland Dental care",
  clinicId: "pearlanddentalcare",
  clinicUrl: "https://pearlanddentalcare.com",

  // Contact Information
  phoneNumber: "(832) 955-1682",
  phoneNumberRaw: "+18329551682", // For tel: and sms: links
  email: "dentalcare@pearlanddentalcare.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=pearlanddentalcare&agentId=1b77c764-5f3a-4c47-a4ee-248249b65dd7",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/pearlanddentalcare/voice",

  // Location
  address: "1921 N Main St #115, Pearland, TX 77581, United States",
  addressShort: "1921 N Main St #115, Pearland, TX 77581",
  city: "Pearland",
  hcity: "Pearland",
  state: "Texas",
  stateShortForm: "TX",
  PostalCode: "77581",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/5BabsZMY1hBg2YUY9",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6596.766832600996!2d-95.285577!3d29.572273!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640913eeb0bb2f3%3A0x53a631dec2ef89d1!2sRoyal%20Dental%20-%20Dentist%20in%20Pearland!5e1!3m2!1sen!2sin!4v1756801646355!5m2!1sen!2sin',
  iframeTitle: "Pearland Dental care",

  //membership
  membership: "https://member.kleer.com/?slug=NE2N",

  // Sunbit
  sunbitUrl: "https://pearlanddentalcare.com/patient-portal",

  // Cherry
  cherryUrl: "https://pearlanddentalcare.com/patient-portal",

  // Analytics
  gaMeasurementId: "G-ST1J7D8YVC",
  clarityProjectId: "sff0eb093t",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/pearlanddentalcare",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/pearlanddentalcare",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/pearlanddentalcare",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://pearlanddentalcare.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61577265572263",
    instagram: "https://www.instagram.com/pearland_dentalcare/",
    twitter: "https://x.com/Pearland_Dent",
    linkedin: "https://www.linkedin.com/company/pearland-dental-care/",
    youtube: "https://www.youtube.com/@pearlandDentalCare",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/3117794044673003178/profile?authuser=4&fid=10401581979612995258",
    facebook: "https://www.facebook.com/pearlanddentalcare/",
    yelp: "",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 9,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 7,
      AppointmentTypeNum: 18,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 9, // DEFAULT_OP_NUM
      AppointmentTypeNum: 27,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 9, // DEFAULT_OP_NUM
      AppointmentTypeNum: 23,
    },
  ],


  // Twilio Configuration
  twilioPhoneNumber: "13466630156",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  membership,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;
